import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import usePersistedState, { StorageType } from '../../../hooks/use-persisted-state';
import { selectKeepSelections } from '../ducks';

const SETTINGS_STORAGE_KEY = 'betslipSettings';

interface BetslipSettings {
	keepSelections: boolean;
}

const usePersistedSettings = () => {
	const keepSelections = useSelector(selectKeepSelections);
	const [settings, setSettings] = usePersistedState<BetslipSettings>(
		SETTINGS_STORAGE_KEY,
		StorageType.SESSION_STORAGE
	);

	useEffect(() => {
		setSettings({ keepSelections });
	}, [keepSelections, setSettings]);

	return settings;
};

export default usePersistedSettings;
